import { displayLogin, snackbar } from "../app/actions";

const NETWORK_ERROR = "Erreur réseau";
const CONNEXION_LOST = "Perte de connexion";
const INTERNAL_ERROR = "Internal server error";

// const ROOT_URL =  process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'production'
//  ? '/api'
//  : 'http://127.0.0.1:9000/api'

const ROOT_URL = "/api";

const HEADERS = {
  "Content-Type": "application/json; charset=utf-8"
};

let reduxStore = null;

const getToken = () => {
  const state = reduxStore.getState();
  if (state.app && state.app.auth) {
    return state.app.auth.token;
  }
};

const authenticatedHeaders = () => {
  const token = getToken();
  return new Headers(token ? { ...HEADERS, Authorization: token } : HEADERS);
};

const gotoLoginScreen = () => {
  reduxStore.dispatch(displayLogin());
  return Promise.reject(CONNEXION_LOST);
};

const inform = msg => {
  const message = typeof msg === "string" ? msg : "";
  reduxStore.dispatch(snackbar(message));
  return Promise.reject(msg);
};

const buildUrl = (path, params = {}) => {
  const qs = Object.keys(params)
    .filter(k => !!params[k])
    .map(k => `${k}=${encodeURIComponent(params[k])}`)
    .join("&");
  const root = `${ROOT_URL}${path}`;
  return qs.length === 0 ? root : `${root}?${qs}`;
};

const request = (method, path, payload, params) => {
  const url = buildUrl(path, params);
  const headers = authenticatedHeaders();
  const body = payload ? JSON.stringify(payload) : undefined;

  return fetch(url, { method, headers, body });
};

const resultHandler = result =>
  result.status === 200
    ? result.json() // We got a result !!! Yeah :)
    : Promise.reject(result); // No result :( To be handled by the caller

const unhandledWrappedError = json =>
  inform(json.error ? json.error : INTERNAL_ERROR);

const unhandledRawError = error => {
  return inform(error); // FIXME : Check how to grab error message
};

const unhandledError = error =>
  error
    .json()
    .then(unhandledWrappedError)
    .catch(unhandledRawError);

const errorHandler = error => {
  switch (error.status) {
    case 400:
      return Promise.reject(error); // To be handled by the caller
    case 401:
      return gotoLoginScreen(); // Authentication token is no longer valid
    case 500:
      return unhandledError(error); // Unhandled error on server inform the user
    default:
      return inform(NETWORK_ERROR); // Inform the user we couldn't reach the server
  }
};

const post = (path, body, params) =>
  request("POST", path, body, params)
    .then(resultHandler)
    .catch(errorHandler);

const get = (path, params) =>
  request("GET", path, null, params)
    .then(resultHandler)
    .catch(errorHandler);

const bind = store => {
  reduxStore = store;
};

export default {
  bind,
  post,
  get,
  buildUrl
};



// WEBPACK FOOTER //
// ./src/services/http.js